// extracted by mini-css-extract-plugin
export var aboutTeam = "_2023-detail-module--aboutTeam--880cf";
export var active = "_2023-detail-module--active--f68b3";
export var groupedContainer = "_2023-detail-module--groupedContainer--0fcdf";
export var sidebar = "_2023-detail-module--sidebar--4eb6b";
export var sidebarHeader = "_2023-detail-module--sidebarHeader--9aa89";
export var sidebarList = "_2023-detail-module--sidebarList--19fd8";